import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=00eb62f2&scoped=true"
import script from "./splash.vue?vue&type=script&lang=js"
export * from "./splash.vue?vue&type=script&lang=js"
import style0 from "./splash.vue?vue&type=style&index=0&id=00eb62f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eb62f2",
  null
  
)

export default component.exports